import { SVGProps, Ref, forwardRef, memo } from 'react';
const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={11} height={11} fill="none" ref={ref} {...props}>
    <g stroke="#383838" strokeLinecap="round" strokeLinejoin="round">
      <path fill="#fff" d="M5.156 9.843a4.464 4.464 0 1 0 0-8.929 4.464 4.464 0 0 0 0 8.929Z" />
      <path d="m3.371 5.826 1.299 1.34c.61-1.756 1.12-2.527 2.273-3.572" />
    </g>
  </svg>
);
const ForwardRef = forwardRef(SvgComponent);
const IconEncircledCheckmark = memo(ForwardRef);
export default IconEncircledCheckmark;
